import { ServerDataSource } from 'angular2-smart-table';
import { Department } from './department';
import { JobRole, Person } from './person';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { filter } from 'lodash';
import { Model } from './common/.base.model';
import { User } from './auth/users';
import { EntityConfigTemplate } from './common/entity-config.interface';

const dPipe: DatePipe = new DatePipe('en');

const statusOptions = [
  { value: 'pending', title: 'Pending' },
  { value: 'in_progress', title: 'In Progress' },
  { value: 'completed', title: 'Completed' },
  { value: 'overdue', title: 'Overdue' },
]

export const TaskConfig: EntityConfigTemplate = {
  meta: { entityName: 'task', entityPluralName: 'tasks', titleField: 'details', view: false, attachedToField: 'user' },
  details: { title: 'Task', type: 'text' },
  due: { title: 'Due Date', valuePrep: (cell: Date, _: any) => dPipe.transform(cell, 'MMM dd, yyyy  HH:mm'), type: 'date' },
  user: { view: false, isPrefilled: true, isForeignKey: true, title: 'User', valuePrep: (_:any, row: Task) => `${row?.user?.firstName ?? ''} ${row?.user?.lastName ?? ''}`  },
  taskStatus: { title: 'Status', type:'select', options: statusOptions }
};


export interface Task extends Model {
  id: number;
  details?: string;
  due: Date;
  user?: User;
  taskStatus: string;
}

export abstract class TaskData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number, query?: string): Observable<Task[]>;
  abstract get(id: any): Observable<Task>;
  abstract update(Task: Task): Observable<Task>;
  abstract create(Task: Task): Observable<Task>;
  abstract delete(id: string): Observable<boolean>;
}

